var map = {
	"./af/common.json": 8557,
	"./af/login.json": 57155,
	"./af/register.json": 29463,
	"./af/welcome.json": 47064,
	"./en/App.json": 23138,
	"./en/Organization.json": 87426,
	"./en/common.json": 83147,
	"./en/login.json": 9459,
	"./en/menu.json": 81507,
	"./en/register.json": 68669,
	"./en/welcome.json": 33067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;